import { Model } from "@tailflow/laravel-orion/lib/model";

export class UnitOfMeasurement extends Model<{
  name: string;
  description: string;
  eway_bill_uom: string;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "unit-of-measurements";
  }
}
